var _circle, _circle2, _path, _circle3, _circle4, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 19.583,
    transform: "matrix(1 0 0 -1 51.25 28.75)",
    fill: "url(#paint0_linear_1288_31983)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.25,
    cy: 28.75,
    r: 13.781,
    fill: "#76808F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2 28.75l7.05-7.05 7.05 7.05-7.05 7.05-7.05-7.05z",
    fill: "#929AA5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 19.583,
    transform: "matrix(1 0 0 -1 28.75 51.25)",
    fill: "#F8D33A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(1 0 0 -1 28.75 51.25)",
    fill: "url(#paint1_linear_1288_31983)",
    r: 13.781
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 51.25l7.05 7.05 7.05-7.05-7.05-7.05-7.05 7.05z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.834 18.75l2.083-2.083 2.084 2.083-2.084 2.083-2.083-2.083zm25 37.916l3.333-3.333 3.334 3.334L54.167 60l-3.333-3.334zM5 39.167L6.667 37.5l1.666 1.667-1.666 1.666L5 39.167zM30 10H10v20l20-20zm20 60h20V50L50 70z",
    fill: "#76808F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_31983",
    x1: 19.583,
    y1: 0,
    x2: 19.583,
    y2: 39.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_31983",
    x1: 13.781,
    y1: 0,
    x2: 13.781,
    y2: 27.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.725e49f23e9de20142a414ddc1f03497.svg";
export { ForwardRef as ReactComponent };